module.exports = __webpack_public_path__ + "static/img/30007 (3).2c43c3d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30007 (3).webp
// module id = MW1d
// module chunks = 14